import React, { useState, useEffect } from 'react'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import sendPost from "../http/sendRequests"

import { useAuthToken, useShowPasswordDialog, useRequestUrl } from "../context/contextHooks"
import {useSxStyles as sx} from "../styles/sxStyles";


const PasswordReset = () => {

	const [authToken] = useAuthToken()
	const [requestUrl] = useRequestUrl()
	const [showPasswordDialog, setShowPasswordDialog] = useShowPasswordDialog()
	const [username, setUsernameState] = useState('')
	const [passwordResetMessage, setPasswordResetMessage] = useState({ success: false, message: '' })
	const [errorMessage, setErrorMessage] = useState('')
	const [loading, setLoading] = useState(false)
	const [displayEntryMessage, setDisplayEntryMessage] = useState(true)

	useEffect(() => {
        if (showPasswordDialog) {
            setErrorMessage('');
			setDisplayEntryMessage(true)
        }
        setLoading(false);
    }, [showPasswordDialog])

	useEffect( () => {
		if (passwordResetMessage.success) {
			setDisplayEntryMessage(false);
		}
	}, [passwordResetMessage])

	const handleSubmit = () => {
		setErrorMessage('')
		if (validate()) {
			setLoading(true)
			const request = { username: username }
			const url = `${requestUrl}/passwordReset`
			sendPost(url, request, `Bearer ${authToken}`, setPasswordResetMessage, setErrorMessage, setLoading)
		}
	}

	const handleCancel = () => {
		setDisplayEntryMessage(true);
		setUsernameState('')
		setPasswordResetMessage({ success: false, message: '' })
		setLoading(false)
		setShowPasswordDialog(false)
	}

	const setUsername = (event) => {
		setUsernameState(event.target.value)
	}

	const validate = () => {
		if (username === '') {
			setPasswordResetMessage({ success: false, message: 'A username or email is required' })
			return false
		}
		// if (username && !(/.+@.+\.[A-Za-z]+$/.test(username))) {
		// 	setPasswordResetMessage({ success: false, message: 'Email entered is not valid' })
		// 	return false
		// }
		return true
	}


	return (
        (<Dialog open={showPasswordDialog} maxWidth='lg'>
            { !loading && 
			<DialogContent>
				<Box>
					{displayEntryMessage && <Typography>Please enter your username</Typography>}
					<TextField name="resetUsername" placeholder="Username (Email)" fullWidth margin="normal" value={username} onChange={setUsername}
						slotProps={{
                            inputLabel: {
                                shrink: true,
                            }
                        }} />
				</Box>
				{passwordResetMessage.success && <Typography>{passwordResetMessage.message}</Typography>}
				{!passwordResetMessage.success && <Typography sx={sx.error}>{passwordResetMessage.message}</Typography>}
				{errorMessage && <Typography sx={sx.error}>{errorMessage}</Typography>}
			</DialogContent>}
            { loading && <DialogContent><CircularProgress /></DialogContent>}
            <DialogActions>
				<Button variant="contained" onClick={handleCancel} color="primary">Cancel</Button>
				{!passwordResetMessage.success && <Button variant="contained" onClick={handleSubmit} color="primary">Submit</Button>}
			</DialogActions>
        </Dialog>)
    );
}

export default PasswordReset